import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Provider/AuthProvider";

const Signup = () => {
    const { signup } = useContext(AuthContext);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [phone, setPhone] = useState("");
    const [postcode, setPostcode] = useState("");
    const [agreed, setAgreed] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        const userData = { email, password, role: "user", name, phone_no: phone, postcode };
        const result = await signup(userData);

        if (result.success) navigate("/login");
        else setError(result.error || "Signup failed");

        setLoading(false);
    };

    return (
        <div className="flex justify-center items-start min-h-screen  bg-red-50 pt-[80px] px-4 pb-20 mt-4">
            <div className="bg-white p-5 rounded-2xl shadow-md w-full max-w-md  flex flex-col overflow-hidden box-border">
                <h2 className="text-2xl font-bold text-red-700 mb-3 text-center">
                    🍽️ Create Your Account
                </h2>

                <div className="flex-1 overflow-y-auto">
                    <form onSubmit={handleSubmit} className="space-y-3">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Full Name</label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="mt-1 w-full p-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
                                placeholder="John Doe"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-1 w-full p-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
                                placeholder="you@example.com"
                                required
                            />
                        </div>

                        {/* Password with show/hide */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Password</label>
                            <div className="mt-1 flex items-center border border-gray-300 rounded-lg focus-within:ring-1 focus-within:ring-red-500 focus-within:border-red-500">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full p-2 rounded-lg outline-none"
                                    placeholder="********"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="text-gray-500 text-sm px-3 py-2"
                                >
                                    {showPassword ? "Hide" : "Show"}
                                </button>
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Phone Number (Optional)</label>
                            <input
                                type="tel"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                className="mt-1 w-full p-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
                                placeholder="+44 7123 456789"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Postcode (Optional)</label>
                            <input
                                type="text"
                                value={postcode}
                                onChange={(e) => setPostcode(e.target.value)}
                                className="mt-1 w-full p-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
                                placeholder="E1 6AN"
                            />
                        </div>

                        {/* Consent */}
                        <div className="space-y-1">
                            <label className="flex items-start space-x-2 text-sm text-gray-600">
                                <input
                                    type="checkbox"
                                    checked={agreed}
                                    onChange={(e) => setAgreed(e.target.checked)}
                                    className="mt-1 text-red-600"
                                    required
                                />
                                <span>
                                    I agree to the Terms & Privacy Policy, and I’d like to receive exclusive offers, updates, bonus coupons via email and SMS.
                                </span>
                            </label>
                        </div>

                        {error && <p className="text-sm text-red-600 text-center">{error}</p>}

                        {/* Submit button */}
                        <button
                            type="submit"
                            disabled={!agreed || loading}
                            onClick={handleSubmit}
                            className="mt-3 w-full bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition disabled:opacity-50"
                        >
                            {loading ? "Signing up..." : "Sign Up"}
                        </button>
                    </form>
                </div>

                <p className="text-sm text-center text-gray-600 mt-2">
                    Already have an account? <a href="/login" className="text-red-600 font-medium">Log in</a>
                </p>
            </div>
        </div>
    );
};

export default Signup;
